module.exports = __webpack_public_path__ + "img/login.ab56a47f.webp";